import { AttentionTypes } from '../../Definitions'
import { Pages } from '../../Navigation/root'
import { LangFile } from '.'

// LAST UPDATE: //NEW 12-11-2025

const Texts:LangFile = {
  // #region | General
  additional: "additional",
  and: "그리고",
  change: "변경",
  choose: "선택",
  deleteFailed: "delete failed", //NEW 03-03-2026
  editFailed: "edit failed", //NEW 03-03-2026
  filterBy: "필터 기준",
  from: "부터",
  general: "general", //NEW 17-11-2025
  no: "아니요",
  noData: "데이터 없음",
  noOptions: "옵션 없음",
  of: "의",
  off: "끔",
  on: "켬",
  optional: "선택 사항",
  page: "페이지",
  reset: "초기화",
  required: "필수",
  saveAlert: "편집 화면을 저장하거나 취소해 주세요.",
  search: "검색",
  select: "선택",
  success: "성공",
  to: "에",
  unknown: "unknown",
  wasUpdated: "was updated", //NEW 05-03-2026
  wasDeleted: "was deleted", //NEW 05-03-2026
  useSelectedTime: "선택한 시간 사용",
  yes: "예",
  // #endregion

  // Regarding the language list:
  // Please translate only your own language. 
  // If your language is not on the list, then add it using a maximum of two 
  // initials followed by a colon and the language in quotation marks.
  languages: { 
    en: "english",
    dk: "dansk",
    es: "español",
    de: "deutsch",
    ma: "mandarin",
    ko: "한국어",
    nl: "nederlands",
  },

  cookie: {
    header: "쿠키",
    context1: "Agrisys A/s는 다음 목적을 위해 쿠키를 사용합니다:",
    context2: `모두 허용" 을 누르면 쿠키 사용에 동의하는 것으로 간주됩니다. 그렇지 않으면 로그인 관리, CONSYS 플랫폼의 데이터 조회 등 서비스 동작에 필요한 최소한의 쿠키만 사용됩니다.`,
    purpose1: "쿠키, 기본 언어, 통화 등 설정을 기억하는 등 웹사이트 기능 지원",
    purpose2: "열람, 클릭한 콘텐츠 유형 측정을 포함한 웹사이트 이용 통계 분석.",
    accept: "필수만 허용",
    acceptAll: "모두 허용"
  },

// #region | Units
  units: {
    animal: "개체",
    animals: "개체",
    units: "단위",
    capacity: "용량",
    day: "일",
    days: "일",
    g: "g",
    hour: "시간",
    hourAgo: "시간 전",
    hours: "시간",
    hoursAgo: "시간 전",
    kg: "KG",
    minutAgo: "분 전",
    minutesAgo: "분 전",
    min: "분",
    pct: "%",
    time: "횟수",
    times: "회",
    timeToday: "오늘 횟수",
    timesToday: "오늘 회",
    total: "합계",
    energy: "에너지",
    gramPerMinute: "분당 그램",
    lenght: "길이"
  },
  // #endregion

// #region | Buttons
buttons: {
  add: "추가",
  apply: "적용",
  cancel: "취소",
  commit: "커밋",
  confirm: "확인",
  create: "생성",
  csv: "CSV",
  deselectAll: "전체 선택 해제",
  details: "상세",
  edit: "편집",
  excel: "Excel",
  filter: "필터",
  goBack: "뒤로 가기",
  menu: "메뉴",
  move: "이동",
  next: "다음",
  options: "옵션",
  prev: "이전",
  print: "인쇄",
  resetFilters: "필터 초기화",
  save: "저장",
  selectAll: "전체 선택"
},
// #endregion

// #region | Menu Headers
menuHeaders: {
  overview: "개요",
  globalMenu: "전역 메뉴",
  systemMenu: "시스템 메뉴",
  attentions: "알림",
  quickEntry: "빠른 입력",
  language: "언어",
  [Pages.dashboard]: "대시보드",
  [Pages.kpi]: "KPI",
  [Pages.feedCurves]: "사료 곡선",
  [Pages.components]: "구성품",
  [Pages.componentsAlternatives]: "대체 구성품",
  [Pages.mixtures]: "배합",
  [Pages.silos]: "사일로",
  [Pages.silosSettings]: "사일로 설정",
  [Pages.animals]: "동물",
  [Pages.animalsGroups]: "동물 그룹",
  [Pages.reports]: "보고서",
  [Pages.archive]: "보관함",
  [Pages.logbook]: "로그북",
  [Pages.globalSettings]: "설정",
  [Pages.devices]: "장치",
  [Pages.freeda_lf]: "개요",
  [Pages.freeda_lf_sections]: "구역",
  [Pages.freeda_lf_settings]: "설정",
  [Pages.op_operations]: "운영",
  [Pages.op_quickEntry]: "빠른 입력",
  [Pages.freeda_esf]: "개요",
  [Pages.freeda_esf_sections]: "구역",
  [Pages.freeda_esf_settings]: "설정"
},
// #endregion

// #region | User
user: {
  userInformation: "사용자 정보",
  user: "사용자",
  userName: "사용자 이름",
  firstName: "이름",
  lastName: "성",
  phone: "전화번호",
  email: "이메일",
  password: "비밀번호",
  repeatPassword: "비밀번호 재입력",
  country: "국가",
  address: "주소"
},
// #endregion

// #region | Farm
farm: {
  farmInformation: "농장 정보",
  farmName: "농장명",
  city: "도시",
  street: "도로명",
  phone: "전화번호",
  vat: "부가세 번호",
  email: "이메일"
},
// #endregion

// #region | Milestones
milestones: {
  general: {
    milestone: "사육 단계",
    milestones: "사육 단계",
    noMilestoneFound: "사육 단계 없음",
    animalsInMilestones: "사육 단계 내 동물",
    latestMilestone: "현재 사육 단계",
    milestoneDay: "현재 사육 단계 일자",
    newMilestone: "새 사육 단계"
  },
  defaultMilestones: {
    farrowing: "분만",
    insemination: "수정",
    weaning: "이유",
    movedToFarrowing: "분만실로 이동"
  }
},
// #endregion

// #region | Events
events: { 
  events: "events", 
  eventName: "name", 
  eventDate: "date", 
  eventNote: "note", 
  addEvent: "add event", 
},
// #endregion

// #region | Devices
devices: {
  devices: "장치",
  name: "이름",
  cpuId: "CPU ID",
  type: "유형",
  connection: "연결",
  system: "시스템",
  noControllersFound: "LAN 컨트롤러 없음",
  lanControllers: "LAN 컨트롤러",
  newLcBoard: "새 LC 보드",
  boardName: "보드 이름",
  noIoBoards: "I/O 보드 없음",
  ioBoards: "I/O 보드",
  newIoBoard: "새 I/O 보드",
  layout: "레이아웃",
  horizontal: "가로",
  vertical: "세로",
  asc: "오름차순",
  desc: "내림차순",
  columns: "열",
  rows: "행",
  order: "순서",
  direction: "방향",
  chooseIo: "I/O 선택",
  remainingInputs: "남은 입력",
  remainingOutputs: "남은 출력",
  aicoIo: "I/O 보드",
  output: "출력",
  input: "입력",
  board: "보드",
  moveBoard: "보드 이동",
  noTerminals: "터미널 없음",
  terminalPort: "터미널 포트",
  pen: "돈방",
  ioSpecifications: "I/O 사양",
  numbering: "번호 매기기",
  manual: "수동",
  automatic: "자동",
  pattern: "패턴",
  topLeft: "왼쪽 상단",
  topRight: "오른쪽 상단",
  bottomLeft: "왼쪽 하단",
  bottomRight: "오른쪽 하단",
  startCorner: "시작 모서리"
},
// #endregion

// #region | System Controls
systemControls: {
  general: {
    startSystem: "시스템 시작",
    systemControls: "시스템 제어",
    emergencyStop: "비상 정지",
    stopSystem: "시스템 정지",
    startAll: "전체 시작",
    startSection: "구역 시작",
    startSelected: "선택 시작",
    calibrateSection: "구역 보정",
    calibrateSelected: "선택 보정",
    emptySection: "구역 비우기",
    emptySelected: "선택 비우기",
    clickPen: "선택할 돈방을 클릭하세요",
    unClickPen: "선택 해제할 돈방을 클릭하세요",
    orSelectAll: "또는 전체 선택",
    orDeselectAlle: "또는 전체 선택 해제",
    problem: "문제",
    problems: "문제",
    warning: "경고",
    warnings: "경고",
    attention: "주의",
    attentions: "주의 알림",
    attentionType: "주의 유형",
    systemState: "시스템 상태",
    staticFeeding: "정적 급이",
    nextFeeding: "다음 급이",
    resolvedWeight: "해소된 중량",
    noPensSelected: "선택된 돈방 없음",
    feeding: "급이 중",
    feedingFailed: "급이 실패",
    calibrating: "보정 중",
    calibratingFailed: "보정 실패",
    changeTime: "시간 변경",
    emptyingFor: "비우는 중",
    emptyingFailed: "비우기 실패",
    confirmStop: "시스템 비상 정지를 진행하시겠습니까?",
    goToSystem: "시스템으로 이동",
    systemStatus: "시스템 상태",
    date: "날짜",
    level: "수준",
    type: "유형",
    inspect: "점검",
    delete: "삭제",
    logid: "로그 ID",
    system: "시스템",
    motor: "모터",
    animal: "동물",
    alerts: "경보",
    location_name: "위치 이름",
    fk_lan_controllers: "FK LAN 컨트롤러",
    lan_controller_log_id: "LAN 컨트롤러 로그 ID",
    attention_message: "주의 메시지",
    attention_time: "주의 시간",
    runningWith: "실행 구성",
    technicalData: "기술 데이터"
  },
  states: {
    [AttentionTypes.good]: "가동 중",
    [AttentionTypes.neutral]: "꺼짐",
    [AttentionTypes.warning]: "경고",
    [AttentionTypes.alert]: "알림"
  },
  createSystem: {
    createNewSystem: "create new system",
    systemName: "system name", 
    systemType: "system type", 
  },
  blueprint: {
    blueprint: "blueprint",
    upload: "upload",
    wrongType: "Error processing file",
    wrongSize: "File is too large (max 500 kB)",
    pleaseDropImage: "Please drop a JPEG file",
    pleaseSelectImage: "Please select a JPEG file",
    dropImage: "Drag and drop your blueprint here",
    browseImage: "Or browse it from your computer",
    chooseFile: "Choose file",
    chooseAgain: "choose again"
  }
},
// #endregion

  // #region | Motor Specs
  motorSpecs: {
    general: {
      skipCnt: "skip count",
      skipTime: "skip time",
      powerConsumption: "power consumption",
      calibrationValue: "calibration value",
      rotationTime: "rotation time",
      statusMode: "status mode",
      noSkip: "No Skip",
      noPowerConsumption: "No Power Consumption",
      noCalibrationValue: "No Calibration Value",
      noRotationTime: "No Rotation Time",
      noStatusMode: "No Status Mode",
    }
  },
  // #endregion

// #region | Params
params: {
  animal: "동물",
  animalId: "개체 번호",
  location: "위치",
  feedCurve: "사료 곡선",
  group: "그룹",
  condition: "상태",
  removeAnimals: "동물 이동",
  resetTotalConsumed: "총 섭취량 초기화",
  manualFeedStart: "수동 급이 시작",
  clearCalendarEvents: "캘린더 이벤트 비우기",
  insemination: "수정",
  weaning: "이유",
  farrowing: "분만",
  pregnancyCheck: "임신 검사",
  birthDate: "출생일",
  pregnant: "임신",
  responderNo: "리스폰더 번호",
  lifeNo: "개체 식별번호",
  animalType: "동물 유형",
  milestone: "사육 단계",
  system: "시스템",
  excess_remaining: "기준 초과 결손"
},
negativeParams: {
  animal: "동물 없음",
  animals: "동물 없음",
  animalId: "개체 번호 없음",
  location: "위치 없음",
  feedCurve: "사료 곡선 없음",
  group: "그룹 없음",
  condition: "상태 없음",
  birthDate: "출생일 없음",
  pregnant: "미임신",
  responderNo: "리스폰더 번호 없음",
  lifeNo: "개체 식별번호 없음",
  animalType: "동물 유형 없음",
  milestone: "이정표 없음",
  system: "시스템 없음",
  ds: "DS 없음",
  energy: "에너지 없음",
  limit: "한도 없음",
  gramPerMinute: "g/분 없음",
  priority: "우선순위 없음",
  protein: "단백질 없음"
},
  // #endregion

configs: {},

// #region | Feed
feed: {
  general: {
    feed: "사료",
    feeding: "급이",
    remainingToday: "오늘 잔량",
    remainingYesterday: "어제 잔량",
    waterUseToday: "오늘 급수량",
    notFed: "최근 2일 섭취율 <20%",
    feedLastDays: "최근 10일",
    currentProgress: "현재 진행률",
    fedLastPeriod: "지난 기간 급이량",
    fedTotal: "총 급이량",
    feedConsumption: "사료 섭취량",
    feedBalance: "사료 수지",
    consumedToday: "오늘 섭취",
    consumedYesterday: "어제 섭취"
  },
  feedCurve: {
    feedCurve: "사료 곡선",
    active: "활성",
    noFeedCurve: "사료 곡선 없음",
    default: "기본값",
    minFeedSpeed: "최소 급이 속도(g/분)",
    maxFeedSpeed: "최대 급이 속도(g/분)",
    feedSpeed: "급이 속도"
  },
  feedCorrection: {
    increased: "증가",
    decreased: "감소",
    disabled: "비활성화",
    feedCorrection: "급이 보정",
    feedCorrections: "급이 보정"
  },
  feedSkip: {
    feedSkip: "급이 건너뛰기",
    skipFeeding: "급이 건너뛰기",
    noSkip: "건너뛰기 없음",
    skipForNow: "지금만",
    planSkip: "계획",
    planFeedSkip: "급이 건너뛰기 계획",
    standardSkip: "표준",
    startFeeding: "급이 시작",
    invalidDay: "잘못된 일자",
    invalidTime: "잘못된 시간",
    endDateBeforeStartDate: "종료일이 시작일보다 빠릅니다",
    endTimeBeforeStartTime: "종료 시간이 시작 시간보다 빠릅니다",
    timeSpan: "기간",
    timeAmount: "시간량",
    startDate: "시작일",
    endDate: "종료일",
    startTime: "시작 시간",
    endTime: "종료 시간",
    plannedSkip: "예정된 건너뛰기",
    recentFeedSkipSuccess: "최근 건너뛰기 성공 상태"
  }
},
// #endregion

// #region | Login Flow
loginFlow: {
  def: {
    fullView: "전체 보기",
    focus_view: "포커스 보기",
    goToSiteList: "사이트 목록으로 이동",
    switchTofocus_view: "포커스 보기로 전환",
    switchToFullView: "전체 보기로 전환"
  },
  login: {
    login: "로그인",
    logOut: "로그아웃",
    welcomeBack: "돌아오신 것을 환영합니다",
    notRegisteredYet: "아직 회원이 아닙니다",
    createNewuser: "새 사용자 생성",
    forgotPassword: "비밀번호 찾기",
    resetPassword: "비밀번호 재설정",
    missingUserName: "사용자 이름이 없습니다",
    missingPassword: "비밀번호가 없습니다",
    couldNotLogin: "로그인 실패",
    noSitesFound: "사이트 없음"
  },
  forgotPassword: {
    forgotPassword: "비밀번호 찾기",
    resetPassword: "비밀번호 재설정",
    text: "사용자 이름에 이메일이 연결되어 있지 않으면 지원팀에 문의하세요.",
    text2: "재설정이 완료될 때까지 이 창을 닫지 마세요.",
    noEmail: "이메일 미지정",
    contactSupport: "지원팀 문의",
    usernameRequired: "사용자 이름 필요",
    noUsernameFound: "사용자 이름이 존재하지 않음"
  },
  resetPassword: {
    resetPassword: "비밀번호 재설정",
    text: "임시 코드가 이메일로 전송되었습니다. 아래에 입력해 새 비밀번호를 생성하세요.",
    temporaryCode: "임시 코드",
    newPassword: "새 비밀번호",
    repeatPassword: "새 비밀번호 재입력",
    createNewPassword: "새 비밀번호 생성",
    contactSupport: "지원팀 문의",
    noPasswordRevieved: "임시 코드를 받지 못했습니다",
    newPasswordFail: "새 비밀번호 생성 실패"
  },
  createUser: {
    newUser: "새 사용자",
    missingUserName: "사용자 이름이 없습니다",
    missingPassword: "비밀번호가 없습니다",
    missingRepeatPassword: "비밀번호를 다시 입력하세요",
    passwordMismatch: "비밀번호 불일치",
    success: "성공"
  },
  chooseSite: {
    chooseSite: "사이트 선택",
    siteName: "사이트명",
    domain: "도메인",
    id: "ID",
    tools: "도구"
  }
},
// #endregion

// #region | Widgets
widgets: {
  general: {
    noWidgets: "이 페이지에는 현재 위젯이 없습니다.",
    widgetOptions: "위젯 옵션",
    manageWidgets: "관리",
    name: "이름",
    type: "유형",
    widgetPriority: "우선순위",
    createNew: "새로 만들기",
    copyExisting: "기존 항목 복사"
  },
  widgetTypes: {
    autoReports: "자동 보고서",
    autoReportsAndMore: "자동 보고서 등",
    graph: "그래프",
    progress: "진행 원형"
  },
  graph: {
    noGraphSelected: "그래프 미선택",
    graphIncludesStart: "그래프에는 모든 동물이 포함됩니다",
    graphIncludesEnd: "사료 섭취 데이터가 있는",
    animalsToInclude: "시스템 기준 포함 동물",
    last10DaysConsumption: "최근 10일 섭취량"
  },
  autoReports: {
    autoReports: "자동 보고서",
    navigatedFromSystem: "시스템에서 이동",
    add: "자동 보고서 추가",
    addExisting: "기존 항목 추가"
  }
},
// #endregion

// #region | Penlist
penList: {
  basicDisclaimer: "값 위에 마우스를 올리면 열 유형이 표시됩니다",
  editDisclaimer: "새 값을 선택해 동물을 편집합니다",
  addDisclaimer: "드롭다운에서 동물을 추가하거나 휴지통 아이콘으로 제거할 수 있습니다",
  moveDisclaimer: "드롭다운으로 새 위치로 이동하거나 휴지통 아이콘으로 제거할 수 있습니다"
},
// #endregion

// #region | Feed Curve pages
feedCurvePages: {
  feedCurves: {
    copyFeedCurve: "사료 곡선 복사",
    createFeedCurve: "사료 곡선 생성",
    createFeedCurveFromScratch: "처음부터 사료 곡선 생성",
    feedCurveDetails: "사료 곡선 상세",
    newFeedCurve: "새 사료 곡선",
    feedCurveName: "사료 곡선 이름",
    fromFeedCurve: "기준 곡선"
  },
  components: {
    components: "구성품",
    emptyText: "구성품 없음",
    name: "구성품 이름",
    readyMixture: "즉시 사용",
    priority: "우선순위",
    ds: "DS",
    energy: "에너지",
    protein: "단백질",
    gramPerMinute: "g/분",
    limit: "한도"
  },
  feedCurve: {
    spreading: "분할 급이",
    spreadings: "분할 급이",
    noSpreading: "분할 없음",
    settings: "설정",
    day: "일",
    watchFeedCurve: "사료 곡선 보기",
    doNotPassFeed: "사료 전달 금지",
    passFeed: "사료 전달",
    stimuli: "자극",
    noStimuli: "자극 없음",
    addStimuli: "자극 추가",
    singleStimuli: "단일 자극",
    repeatStimuli: "반복 자극",
    maxAmount: "기간 최대량(kg)",
    remainingFeed: "잔여 사료",
    maxFeedToPass: "전달 최대 kg",
    max: "최대",
    feeding: "급이",
    feedings: "급이(횟수)",
    feedStimuli: "급이 자극",
    minutesApart: "분 간격",
    addTime: "시간 추가",
    saveChanges: "변경 사항 저장",
    resetChanges: "변경 사항 초기화",
    feedCurveLenght: "길이",
    feedLimit: "급이 한도",
    animalCount: "동물 수",
    consumedToday: "오늘 섭취"
  }
},
// #endregion

// #region | Animal pages
animalPages: {
  animals: {
    animals: "동물",
    emptyText: "동물 없음",
    quickEntry: "빠른 입력",
    newAnimal: "새 동물",
    viewChanges: "변경 보기",
    action: "작업",
    selectAnimals: "동물 선택",
    missingAnimalNo: "개체 번호 없음",
    missingResponderNo: "리스폰더 번호 없음",
    kgFedMore: "예상보다 급이량 초과(kg)",
    noAnimalsMatchTheSelection: "선택과 일치하는 동물 없음"
  },
  animalGroups: {
    group: "그룹",
    numberOfAnimals: "동물 수",
    createGroup: "그룹 생성",
    newGroup: "새 그룹",
    groupName: "그룹명"
  },
  animal: {
    animal: "동물",
    basicInfo: "기본 정보",
    noAnimalSelected: "동물 선택 안 됨",
    noAnimalsSelected: "동물 선택 안 됨",
    addAnimal: "동물 추가",
    addAnimalToPen: "돈방에 동물 추가",
    pen: "돈방",
    moveAnimal: "동물 이동",
    moveAnimals: "동물 이동",
    moveAnimalFromPen: "돈방으로 이동",
    goToAnimal: "동물 페이지로 이동",
    totalCycleDay: "총 사이클 일수",
    marking: "표식",
    events: "이벤트",
    eventName: "이름",
    eventDate: "날짜",
    eventNote: "메모",
    noTimeline: "타임라인 없음",
    addEvent: "이벤트 추가",
    timeline: "타임라인",
    viewTimeline: "타임라인 보기",
    born: "출생",
    timelineShows: "타임라인에 산차 표시",
    parity: "산차"
  }
},
// #endregion

// #region | Report pages
reportPages: {
  reports: {
    template: "템플릿",
    templateName: "템플릿 이름",
    addTemplate: "템플릿 추가",
    copyTemplate: "템플릿 복사",
    createReport: "보고서 생성",
    createNewReport: "처음부터 새 보고서 시작",
    newTemplate: "새 템플릿",
    newReport: "새 보고서",
    dataLevel: "데이터 레벨",
    filterParameter: "필터 파라미터",
    dataParameter: "데이터 파라미터",
    reportName: "보고서 이름",
    archiveReport: "보고서 보관",
    startDate: "시작일",
    endDate: "종료일",
    showInReport: "보고서에 표시",
    fromTemplate: "템플릿에서",
    noReportFound: "보고서 없음",
    noDataParameterFound: "데이터 파라미터 없음",
    unknownCondition: "알 수 없는 조건",
    unknownAnimalGroup: "알 수 없는 그룹",
    noFilterParameterFound: "필터 파라미터 없음",
    saveAsTemplate: "템플릿으로 저장"
  },
  report: {
    report: "보고서",
    editReport: "보고서 편집",
    unArchiveReport: "보관 해제",
    saveAsTemplate: "템플릿으로 저장",
    noReport: "보고서 없음"
  },
  archive: {
    archive: "보관함",
    filterByNumber: "보고서 번호",
    filterByName: "보고서명(알파벳순)",
    archivedReport: "보관된 보고서",
    noStartDateFound: "시작일 없음",
    noEndDateFound: "종료일 없음"
  }
},
  // #endregion

  // #region | Logbook pages
  logPages: {
    logbook: {
      problem: "Problem",
      warning: "Warning",
      info: "Info",
      debug: "Debug",
      system: "System",
      motor: "Motor",
      animal: "Animal",
      time: "time",
      level: "level",
      type: "type",
      message: "message",
      location: "location",
      controller: "controller",
      allControllers: "all controllers",
      controllerName: "controller name",
      deviceName: "device name",
      lanControllers: "lan controllers",
      getLog: "get log",
      noLogsAvailable: "no logs available",
      responder: "responder",
    },
  },
  // #endregion

// #region | Global Settings pages
globalSettingsPages: {
  globalSettings: {
    imperial: "야드파운드법",
    metric: "미터법",
    saveChanges: "변경 사항 저장",
    discardChanges: "변경 사항 폐기",
    userManagement: "사용자 관리",
    timeZone: "시간대",
    feedDayStart: "급이일 시작",
    remove: "제거"
  }
},
// #endregion

// #region | Location Feeder Pages
locationFeederPages: {
  locationFeeder: {
    sections: "구역",
    pens: "돈방",
    animals: "동물",
    sectionNo: "구역 번호",
    pen: "돈방"
  },
  sections: {
    section: "구역",
    sections: "구역",
    map: "지도",
    animalAmount: "동물 수",
    penValueHeaders: "값 위에 마우스를 올리면 열 유형이 표시됩니다",
    sectionNotFound: "구역 없음",
    emptyPen: "빈 돈방",
    feeder: "급이기",
    inThisPen: "이 돈방",
    activations: "활성화",
    lastActivated: "마지막 활성화",
    newSection: "새 구역",
    sectionName: "구역명",
    firstPenNo: "첫 돈방 번호",
    penAmount: "돈방 수",
    clickOnPen: "돈방을 클릭해 추가/제거",
    penContent: "돈방 내용",
    feederOnly: "급이기만",
    water: "급수",
    activator: "액티베이터",
    feederOutput: "급이기 출력",
    waterOutput: "급수 출력",
    activatorInput: "액티베이터 입력",
    since: "이후",
    redirect: "동물 페이지로 이동합니다.",
    expand: "펼치기",
    collapse: "접기",
    noSections: "구역 없음"
  },
  settings: {
    dailyRotation: "일일 회전",
    dailyRotationDisclaimer: "위치가 비어 있거나 동물에 사료 곡선이 없으면 서비스 목적으로 모터가 일일 회전을 수행합니다.",
    feedInSilos: "사일로 내 사료",
    attentionLimit: "주의 한계치"
  }
},
// #endregion

// #region | ESF Walk Through Pages
esfWalkThroughPages: {
  esfWalkThrough: {
  },
  sections: {
    station: "스테이션",
    feedMotor: "급이 모터",
    feedSensor: "급이 센서",
    gateMotor: "게이트 모터",
    gateSensor: "게이트 센서",
    inThisStation: "이 스테이션에서",
    previously: "이전",
    feedComponents: "사료 구성품",
    stationLastDays: "최근 10일",
    stationLog: "로그"
  },
  settings: {
  }
},
// #endregion

// #region | Focus View Pages
focus_viewPages: {
  location: "위치",
  system: "시스템",
  section: "구역",
  inThisPen: "이 돈방",
  today: "오늘",
  pen: "돈방",
  since: "이후",
  day: "일",
  moveAnimal: "동물 이동",
  newLocation: "새 위치",
  emptyPen: "빈 돈방"
}
// #endregion
}
export default Texts